import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    selectAllCheckbox: {
        marginHorizontal: Theme.BU,
        borderColor: Theme.primaryTextColor
    },
    selectAllText: {
        fontFamily: Theme.boldFont,
        fontSize: 19,
        marginLeft: 10,
        color: Theme.primaryTextColor
    },
    selectAllWrapper: {
        marginHorizontal: Theme.primaryMargin / 2,
        flexDirection: 'row-reverse'
    },
    checkboxHr: {
        marginHorizontal: Theme.primaryMargin,
        marginTop: 10
    }
};

export default StyleSheet.create(baseStyles);
